import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ICurrentWorkspaceBl } from '../../CurrentWorkspace.bl';
import { CurrentWorkspaceSelectAction } from './CurrentWorkspaceSelectAction';

interface IProps {
  workspaceId: string;
}

export const CurrentWorkspaceSelectActionContainer = observer((props: IProps): ReactElement => {
  const bl = useInjection(ICurrentWorkspaceBl.$);

  return (
    <CurrentWorkspaceSelectAction
      onClick={bl.selectWorkspace}
      workspaceId={props.workspaceId}
    />
  );
});
